import {
  AdvancedSearchField,
  AdvancedSearchQualifier,
  searchOperatorMap,
} from '../constants';

export interface FieldQualifierValue {
  field: AdvancedSearchField;
  qualifier: AdvancedSearchQualifier;
  value: string;
}

const getValueWithAsterisks = ({ qualifier, value }: FieldQualifierValue) =>
  `${qualifier !== AdvancedSearchQualifier.startsWith ? '*' : ''}${value}*`;

const getQueryWithQualifier = ({
  fieldMap,
  field,
  qualifier,
  value,
  isSpaceSeparated = false,
  customOperator = '',
}: {
  fieldMap: Record<string, string>;
  isSpaceSeparated?: boolean;
  customOperator?: string;
} & FieldQualifierValue) => {
  const mappedOperator = customOperator || searchOperatorMap[qualifier];
  const formattedOperator = isSpaceSeparated
    ? ` ${mappedOperator} `
    : mappedOperator;

  return `${fieldMap[field]}${formattedOperator}"${value}"`;
};

export const getCqlFieldQualifierValue =
  (fieldMap: Record<string, string>) =>
  ({ field, qualifier, value }: FieldQualifierValue): string => {
    if (
      qualifier === AdvancedSearchQualifier.exactPhrase ||
      qualifier === AdvancedSearchQualifier.equal
    ) {
      return getQueryWithQualifier({
        fieldMap,
        field,
        qualifier,
        value,
      });
    }

    const formattedValue =
      qualifier === AdvancedSearchQualifier.startsWith
        ? getValueWithAsterisks({ qualifier, value, field })
        : value;

    return getQueryWithQualifier({
      fieldMap,
      field,
      qualifier,
      value: formattedValue,
      isSpaceSeparated: true,
    });
  };
